/**
 * Client hook for the cache-card-image Edge Function (Phase 4).
 *
 * After a lot is saved with an external catalog image URL (pokemontcg.io /
 * Scryfall / TCGplayer CDNs), fire-and-forget a request for the server to
 * copy that image into OUR Supabase Storage and swap the row's Image URL.
 * The in-memory row keeps the external URL until the next reload - display
 * still works either way; this is durability, not correctness.
 *
 * The row's cloud UUID is assigned asynchronously on first insert, so we
 * poll briefly for `_uuid` before invoking.
 */
import { sb } from "./supabase";

const EXTERNAL_HOSTS = [
  "images.pokemontcg.io",
  "cards.scryfall.io",
  "c1.scryfall.com", "c2.scryfall.com", "c3.scryfall.com",
  "product-images.tcgplayer.com",
  "tcgplayer-cdn.tcgplayer.com",
];

export function isExternalCatalogImage(url: string | undefined | null): boolean {
  try { return EXTERNAL_HOSTS.includes(new URL(String(url || "")).hostname); }
  catch { return false; }
}

/** Queue a server-side image cache for a just-saved cards/sealed row. Silent
 *  best-effort: failures simply leave the external URL in place. */
export function queueImageCache(table: "cards" | "sealed", row: Record<string, any> | null | undefined): void {
  if (!row || !isExternalCatalogImage(row["Image URL"])) return;
  const fire = (uuid: string) => {
    void sb.functions.invoke("cache-card-image", { body: { mode: "single", table, id: uuid } })
      .catch(() => { /* best effort */ });
  };
  const tryFire = (attemptsLeft: number) => {
    const uuid = (row as any)._uuid;
    if (uuid) { fire(String(uuid)); return; }
    if (attemptsLeft > 0) setTimeout(() => tryFire(attemptsLeft - 1), 1000);
  };
  tryFire(10);
}
